import { call, put, takeEvery } from 'redux-saga/effects';
import { getBikeModels } from '../../requests/get_bike_models_request';
import { getBikeModelsSuccess, getBikeModelsFailure } from '../actions/get_bike_models.actions';
import { GET_BIKE_MODELS_LEAD_CREATE_REQUEST } from '../constants/get_bike_models.constants';

function* getBikeModelsRequest({ params }) {
    const models = yield call(getBikeModels, params); const
        { msg, options } = models;

    models
        ? yield put(getBikeModelsSuccess(options))
        : yield put(getBikeModelsFailure(msg));
}

export default function* getBikeModelsSaga() {
    yield takeEvery(GET_BIKE_MODELS_LEAD_CREATE_REQUEST, getBikeModelsRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/sagas/get_bike_models.saga.js